import { render, staticRenderFns } from "./ApproveInspections.vue?vue&type=template&id=cf0447d8&scoped=true&"
import script from "./ApproveInspections.vue?vue&type=script&lang=ts&"
export * from "./ApproveInspections.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveInspections.vue?vue&type=style&index=0&id=cf0447d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0447d8",
  null
  
)

export default component.exports